import { Box, Heading, Text } from '@chakra-ui/react'
import React from 'react'

const About = () => {
    return (
        <Box w="80%" m={'auto'} >
            <Heading my={5} textAlign="center" textDecor={"underline"}>About Us</Heading>
            <Text>Our team management application offers a user-friendly platform to streamline communication and task management within organizations. With the ability to assign tasks and receive real-time updates, managers can stay on top of their team's progress. We prioritize clear communication channels to ensure that all team members stay informed, regardless of their location or time zone. Our goal is to help organizations achieve greater efficiency and productivity by making team management a seamless process. Try our application today to take your team's performance to the next level.</Text>
        </Box>
    )
}

export default About
